import apiClient from './client.js'

/**
 * 認証API
 *
 * OTP認証フロー:
 * 1. requestOtp() - メールアドレスでOTPコード要求
 * 2. verifyOtp() - OTPコード検証してJWTトークン取得
 */

export const authApi = {
  /**
   * OTP認証コード要求
   * @param {Object} data - { email: string }
   * @returns {Promise<Object>} { success: boolean, is_new_user: boolean, message: string }
   */
  async requestOtp(data) {
    const response = await apiClient.post('/console/v1/auth/request-otp', data)
    return response.data
  },

  /**
   * OTPコード検証
   * @param {Object} data - { email: string, otp_code: string }
   * @returns {Promise<Object>} { success: boolean, data: { token: string, user: Object } }
   */
  async verifyOtp(data) {
    const response = await apiClient.post('/console/v1/auth/verify-otp', data)
    return response.data
  },

  /**
   * マジックリンク認証
   * @param {string} token - マジックリンクトークン
   * @returns {Promise<Object>} { success: boolean, data: { token: string, user: Object } }
   */
  async verifyMagicLink(token) {
    const response = await apiClient.get(`/console/v1/auth/magic/${token}`)
    return response.data
  },

  /**
   * ログアウト
   * @returns {Promise<Object>}
   */
  async logout() {
    const response = await apiClient.post('/console/v1/auth/logout')
    return response.data
  },

  /**
   * 現在のユーザー情報取得
   * @returns {Promise<Object>} { success: boolean, data: User }
   */
  async getCurrentUser() {
    const response = await apiClient.get('/console/v1/user')
    return response.data
  },

  /**
   * トークンリフレッシュ（未実装）
   * @param {string} refreshToken
   * @returns {Promise<Object>}
   */
  async refreshToken(refreshToken) {
    // 将来の実装用
    throw new Error('Token refresh not implemented yet')
  }
}

export default authApi
